import Competence from "constants/Competence";
import competenceMap from "constants/CompetenceMap";
import GceContrats from "constants/GceContrats";
import { GepuSousCompetencesId } from "constants/GepuSousCompetencesId";
import { EauAssPorteesId, EauAssSousCompetencesId } from "constants/PorteesEauAss";
import type { BaseTransfert } from "models";
import { SdeappsError } from "utils/errorHandling";

function getCompetence(transfert: BaseTransfert | string): Competence {
  const transfertCode: string = isInstanceOfTransfert(transfert) ? transfert?.code : transfert;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, _competence, _sousCompetenceId, _porteeId] = decomposePorteeCode(transfertCode);

  const competence = competenceMap.get(_competence as Competence);

  if (competence == null) {
    throw new SdeappsError(`Competence non trouvée dans le code transfert '${transfertCode}'`);
  }

  return competence.competence;
}

function isInstanceOfTransfert(object: BaseTransfert | string): object is BaseTransfert {
  return typeof object !== "string";
}

function getSousCompetenceId(transfert: BaseTransfert | string): string {
  const transfertCode: string = isInstanceOfTransfert(transfert) ? transfert?.code : transfert;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, _competence, _sousCompetenceId, _porteeId] = decomposePorteeCode(transfertCode);

  if (_sousCompetenceId === "") {
    throw new SdeappsError(`SousCompetence non trouvée dans le code transfert ${transfertCode}`);
  }

  return _sousCompetenceId;
}

function getSousCompetenceLabel(transfert: BaseTransfert | string): string {
  let sousCompetenceLabel: string | undefined;

  switch (getCompetence(transfert)) {
    case Competence.EAU:
    case Competence.ASS:
      sousCompetenceLabel = EauAssSousCompetencesId[getSousCompetenceId(transfert)];
      break;
    case Competence.GCE:
      sousCompetenceLabel = GceContrats.find(
        (c) => c.code === porteesUtil.getSousCompetenceId(transfert)
      )?.nom;
      break;
    case Competence.GEPU:
      sousCompetenceLabel = GepuSousCompetencesId[getSousCompetenceId(transfert)];
      break;
  }

  return sousCompetenceLabel ?? "";
}

function getPorteeId(transfert: BaseTransfert | string): number {
  const transfertCode: string = isInstanceOfTransfert(transfert) ? transfert?.code : transfert;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, _competence, _sousCompetenceId, _porteeId] = decomposePorteeCode(transfertCode);

  if (_porteeId === "") {
    throw new SdeappsError(`Portée non trouvée dans le code transfert ${transfertCode}`);
  }

  return Number.parseInt(_porteeId, 10);
}

function getPorteeLabel(transfert: BaseTransfert | string): string {
  let porteeLabel: string = "";

  switch (getCompetence(transfert)) {
    case Competence.EAU:
    case Competence.ASS:
      porteeLabel = EauAssPorteesId[getPorteeId(transfert)];
      break;
    case Competence.GCE:
    case Competence.GEPU:
      break;
  }

  return porteeLabel;
}

function decomposePorteeCode(
  codeTransfert: string
): [_: string, competence: string, sousCompetenceId: string, porteeId: string] {
  return (/^([A-Z]+)-((?:[A-Z]|\d)+)-(\d+)$/gi.exec(codeTransfert) ?? ["", "", "", ""]) as [
    _: string,
    competence: string,
    sousCompetenceId: string,
    porteeId: string,
  ];
}

export const porteesUtil = {
  getCompetence,
  getSousCompetenceId,
  getSousCompetenceLabel,
  getPorteeId,
  getPorteeLabel,
};
